import { multipleValueSelectOperators } from "../constants/filter-types/autocomplete-multipe-selection-operator-types";
import { ResourceExplorerTagFilterOperator } from "../../../../../../services/cloudchipr.api";

export const operatorTypeChanged = (
  prevOperator: ResourceExplorerTagFilterOperator,
  currentOperator: ResourceExplorerTagFilterOperator,
): boolean => {
  return (
    (multipleValueSelectOperators.includes(currentOperator) &&
      multipleValueSelectOperators.includes(prevOperator)) ||
    (!multipleValueSelectOperators.includes(currentOperator) &&
      !multipleValueSelectOperators.includes(prevOperator))
  );
};
